import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PrivateRoute from "./routes/Private.routes"; // Atualize este caminho para o local correto do seu arquivo PrivateRoute
import GlobalStyles from "./styles/global";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./styles/themes/light";
import HomeRoutes from "./routes/Home.routes";
import LoginRoute from "./routes/Login.routes";
import Homepage from "./pages/Home/components/Home.page";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <Router>
        <AnimatePresence mode="wait">
          <GlobalStyles />
          <Routes>
            <Route element={<LoginRoute />}>
              <Route path="/login" element={<Homepage />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route index path="/*" element={<HomeRoutes />} />
              <Route path="/*" element={<Navigate to="/" />} />
            </Route>
          </Routes>
        </AnimatePresence>
      </Router>
    </ThemeProvider>
  );
};

export default App;
